<template lang="html">
  <section class="locations">
    <h1 class="title"><span>Locations</span></h1>
    <ul class="locations__list">
      <LocationItem v-for="(location, index) in locations" :key="location.label" :label="location.label" :image="location.image" :index="index" @handleClick="openImage($event, {image:location.image, label:location.label, index})"/>
    </ul>
    <transition name="fade">
      <aside class="locations__imageContainer" ref="imageContainer" v-show="focusOpened" v-hammer:tap="closeImage" v-hammer:swipe="onSwipe">
        <div :style="{backgroundImage: `url(${selectedImage.image})`}"></div>
        <aside class="locations__textContainer">
          <h2>{{selectedImage.label}}</h2>
          <img src='../assets/keyboard.svg' alt="">
        </aside>
      </aside>
    </transition>
  </section>
</template>

<script>
import anime from 'animejs';
import LocationItem from '../components/LocationItem.vue';

export default {
  name: 'Locations',
  components: {
    LocationItem
  },
  updated() {
    anime({
      targets: '.locationItem',
      opacity: [0,1],
      translateY: ["20px", 0],
      translateZ: 0,
      duration: 1000,
      easing: 'easeInOutCubic',
      delay: function(el, i) {
        return 300 * i + 1500;
      }
    });
    document.querySelector('.locations__imageContainer').style.height = window.innerHeight + 'px';
  },
  data() {
    return {
      selectedImage: {image:'',index:''},
      focusOpened: false
    }
  },
  computed: {
    locations() {
      return this.$store.state.locations;
    },
    pageCopy() {
      return this.$store.state.locationsCopy;
    }
  },
  methods: {
    openImage(event, nextImage) {
      this.selectedImage = nextImage;
      this.focusOpened = true;
      document.querySelector('body').style.overflow = 'hidden';
      window.addEventListener('keyup', this.onKey)
    },
    closeImage() {
      this.focusOpened = false;
      document.querySelector('body').style.overflow = 'hidden auto';
      window.removeEventListener('keyup', this.onKey);
      setTimeout(() => {
        this.selectedImage = {image:'',index:'',label:''};
      }, 500);
    },
    onKey(event) {
      if(event.keyCode === 37) this.goToPrev();
      else if (event.keyCode === 39) this.goToNext();
    },
    onSwipe(event) {
      if (event.direction === 2) this.goToNext();
      if (event.direction === 4) this.goToPrev();
    },
    goToPrev() {
      if (this.selectedImage.index === 0) return;
      const newIndex = this.selectedImage.index - 1;
      const imageContainer = this.$refs.imageContainer;
      imageContainer.classList.add('slide');
      setTimeout(() => {
        this.selectedImage = {
          image: this.locations[newIndex].image,
          label: this.locations[newIndex].label,
          index: newIndex
        }
        setTimeout(() => {
          imageContainer.classList.remove('slide');
        },100)
      }, 400)
    },
    goToNext() {
      if (this.selectedImage.index === this.locations.length - 1) return;
      const newIndex = this.selectedImage.index + 1;
      const imageContainer = this.$refs.imageContainer;
      imageContainer.classList.add('slide');
      setTimeout(() => {
        this.selectedImage = {
          image: this.locations[newIndex].image,
          label: this.locations[newIndex].label,
          index: newIndex
        }
        setTimeout(() => {
          imageContainer.classList.remove('slide');
        },100)
      }, 400)
    }
  }
}
</script>

<style lang="scss">
@import "../styles/config.scss";
.locations {
  max-width: 1240px;
  width: 100%;
  margin: 0 auto;
  &__list {
    margin: 100px auto 0;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-row-gap: 40px;
    grid-column-gap: 60px;
  }
  &__imageContainer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    z-index: 2;
    cursor: url('../assets/crossX.svg') 4 4, auto;
    transition: all .4s ease-out;
    background-color: var(--Neu10);
    display: flex;
    align-items: flex-end;
    div {
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      top: 0;
      left: 0;
      height: 100vh;
      width: 100vw;
      position: absolute;
      transition: all .3s ease-out;
    }
    &.slide {
      div {
        opacity: 0;
      }
      h2 {
        opacity: 0;
        transform: translateX(20px);
      }
    }
  }
  &__textContainer {
    width: 100%;
    max-width: 1240px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h2 {
      font-family: CamptonBold;
      font-size: 28px;
      color: var(--Neu01);
      margin-top: 40px;
      margin-bottom: 30px;
      line-height: 1.35;
      opacity: 1;
      transform: translateX(0);
      transition: all .3s ease-out;
    }
    img {
      width: 50px;
    }
  }
  @include mq(0, 1024px) {
    &__list {
      grid-row-gap: 20px;
      grid-column-gap: 40px;
    }
  }
  @include mq(0, 768px) {
    &__list {
      margin-top: 40px;
      grid-template-columns: repeat(2, 1fr);
      grid-row-gap: 20px;
      grid-column-gap: 40px;
    }
  }
  @include mq(0, 512px) {
    &__list {
      grid-template-columns: repeat(1, 1fr);
      grid-row-gap: 20px;
      grid-column-gap: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/Locations.vue